export const editor = {
  colorScheme: {
    light: {
      background: '{surface.100}',
      borderColor: '{primary.400}',
      color: '{paginator.color}',
      navButton: {
        color: 'black',
        selectedColor: 'black',
      },
      toolbar: {
        borderColor: 'transparent',
        background: '#eef4f7',
        color: '',
        item: {
          hoverColor: '#274c6e',
          activeColor: '#14a08c',
          color: '#5b6b7c',
        },
      },
      overlay: {
        borderColor: 'transparent',
        background: '#e3eaef',
        color: '#0e2a4a',
        item: {
          color: '#0e2a4a',
        },
      },
      content: {
        borderColor: 'transparent',
        background: '#f7fafb',
        color: '#0e2a4a',
        item: {
          color: '#ffffff',
        },
      },
    },
    dark: {
      color: '#ffffff',

      toolbar: {
        borderColor: 'transparent',
        background: ' #586274',
        color: '#ffffff',
        item: {
          hoverColor: '#b6bdc8',
          activeColor: '#4db8ff',
          color: '#ffffff',
        },
      },
      overlay: {
        borderColor: 'transparent',
        background: '#3C434F',
        color: '#ffffff',
        item: {
          color: '#ffffff',
        },
      },
      overlayOption: {
        borderColor: 'transparent',
        background: '#3C434F',
        color: '#ffffff',
        item: {
          color: '#ffffff',
        },
      },
      content: {
        borderColor: 'transparent',
        background: '#333842',
        color: '#ffffff',
        item: {
          color: '#ffffff',
        },
      },
    },
  },
};
